import { combineReducers } from "redux";
import Auth from "./auth/reducers";
import { ChatMessages } from "./chat/reducers/chatMessages";
import { fileUpload } from "./chat/reducers/fileUpload";
import { typingIndicator } from "./chat/reducers/typingIndicator";
import { UserMessage } from "./socket/reducers";
const rootReducer = combineReducers({
  Auth,
  UserMessage,
  ChatMessages,
  fileUpload,
  typingIndicator,
});

export type AppState = ReturnType<typeof rootReducer>;

export default rootReducer;
